class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.loading = false;
    this.isOpen = false;
    this.sectionId = this.dataset.sectionId;
    if (window.fixLoginLinks) {
      const selectors = [
        '.cart-message__promo'
      ];
      window.fixLoginLinks(selectors);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll("#cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();
        this.open(cartLink);
        this.sendOpenCartTrackingEvent();
      });
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.stopImmediatePropagation();
          event.preventDefault();
          this.open(cartLink);
          this.sendOpenCartTrackingEvent();
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const dialog = this.querySelector(".drawer__inner");
        const focusTarget =
          dialog.querySelector(".drawer__close") || dialog;

        trapFocus(dialog, focusTarget);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
    this.isOpen = true;
  }

  close() {
    this.classList.remove("active");

    removeTrapFocus(this.querySelector(".drawer__inner"));

    document.body.classList.remove("overflow-hidden");
    this.isOpen = false;

    if (this.activeElement) {
      this.activeElement.focus();
      this.activeElement = null;
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: this.sectionId,
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      }
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setLoading() {
    this.querySelector(".drawer__inner__loading-overlay").classList.add(
      "drawer__inner__loading-overlay--active"
    );
    this.loading = true;
  }

  setNotLoading() {
    this.querySelector(".drawer__inner__loading-overlay").classList.remove(
      "drawer__inner__loading-overlay--active"
    );
    this.loading = false;
  }

  sendOpenCartTrackingEvent() {
    const trackingInfo = this.querySelector("#tracking-data")
      ? JSON.parse(this.querySelector("#tracking-data").content.textContent)
      : null;

    if (!trackingInfo) {
      return;
    }

    const trackingData = {
      event: "view_cart",
      ecommerce: {
        currency: trackingInfo.currency,
        value: trackingInfo.value,
        items: trackingInfo.items.map((item, index) => ({
          item_id: item.item_id,
          item_name: item.item_name,
          affiliation: "Victoria Beckham Beauty",
          currency: trackingInfo.currency,
          ...(item.discount && {
            discount: item.discount,
          }),
          ...(item.coupon && {
            coupon: item.coupon,
          }),
          index,
          item_brand: "Victoria Beckham Beauty",
          ...(item.item_variant != null && {
            item_variant: item.item_variant,
          }),
          price: parseFloat(item.price),
          quantity: parseInt(item.quantity, 10),
        })),
      },
    };

    window.Shopify.analytics.publish("custom_cart_viewed", trackingData);
  }
  fixAccountAuthLinks() {
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: document.querySelector('cart-drawer').sectionId,
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
